"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebmString = void 0;
const WebmBase_1 = require("./WebmBase");
class WebmString extends WebmBase_1.WebmBase {
    constructor(name, start = 0) {
        super(name, start);
    }
    getType() {
        return "String";
    }
    updateBySource() {
        this.data = this.source;
    }
    updateByData() {
        this.source = this.data;
    }
    getValue() {
        let result = "";
        this.source.forEach((code) => {
            result += String.fromCharCode(code);
        });
        return result;
    }
}
exports.WebmString = WebmString;
//# sourceMappingURL=WebmString.js.map